/*
 * @Author: changcheng
 * @LastEditTime: 2023-04-20 09:42:06
 */
import React, { useEffect, FC, useState } from "react";
import { connect } from "react-redux";
import { Tooltip, Divider, message } from "antd";

import "./index.less";
import axios from "@/axios/axios";
import { withRouter } from "react-router-dom";
import * as actions from "@/store/actions";
import { RightCircleOutlined } from "@ant-design/icons";
const News: FC<any> = ({ history, setNews }) => {
  // 资讯列表
  const [newsList, setNewsList] = useState([] as any[]);
  const getNews = async () => {
    const { code, data, msg }: any = await axios.post(
      "/main/front/ce/information/list",
      {
        currentPage: 1,
        pageSize: 8,
      }
    );
    if (code === 0) {
      setNewsList(data.informationList || []);
    } else {
      message.error(msg);
    }
  };

  const imgJump = (data: any) => {
    setNews({ news: data });
    history.push(`/index/news?id=${data.id}`);
  };

  useEffect(() => {
    getNews();
  }, []);

  return (
    <div className={"news-module"}>
      <div className={"home-title-bar"}>
        <span className={"title"}>继教资讯</span>
        <span
          className={"more"}
          onClick={() => {
            history.push("/index/newsInfo");
          }}
        >
          更多
          <span>
            <RightCircleOutlined
              style={{ fontSize: "16px", marginLeft: "8px" }}
            />
          </span>
        </span>
      </div>
      <div className={"news-list"}>
        <ul>
          {newsList.map((item: any, i: number) => (
            <li
              key={i}
              onClick={() => {
                imgJump(item);
              }}
            >
              <Tooltip>
                <p>{item.title}</p>
              </Tooltip>
              <span className={"news-time"}>
                {item.createTime.split(" ")[0]}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(withRouter(News));
